import React from "react";


export function PrimaryButton({ children, className = "", ...props }) {
  return (
    <button className={`btn-primary ${className}`} {...props}>{children}</button>
  );
}

export function OutlineButton({ children, className = "", ...props }) {
  return (
    <button className={`btn-outline ${className}`} {...props}>{children}</button>
  );
}

